import { useStyles } from '../styles/NewOrUpdateForm.styles';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid, FormControl, TextField, Typography } from '@mui/material';

import { useState } from 'react';
import type { SyntheticEvent } from 'react';

interface MultiSelectProps {
    error?: boolean;
    options: { name: string; id: string }[];
    label: string;
    state: { id: string; name: string }[];
    dispatch: (selected: { id: string; name: string }[], newData: { id: string; name: string }[]) => void;
    disable?: boolean;
    size?: number;
    includeAll?: boolean;
}

export const GridMultiSelect = ({
    error,
    options,
    label,
    state,
    dispatch,
    disable,
    size,
    includeAll = true,
}: MultiSelectProps) => {
    const classes = useStyles();
    const allOption = includeAll && options.length ? [{ id: '*', name: 'All ' }, ...options] : options;
    const [open, setOpen] = useState<boolean>(false);

    const handleOpen = () => {
        if (disable === true) {
            return;
        }

        setOpen(true);
    };

    return (
        <Grid item md={size ?? 6} xs={12} sm={12} className={classes.textInputWrapper}>
            <Typography variant='body2' color={error ? 'error' : 'text.primary'} fontWeight={1000} sx={{ pl: 0.5 }}>
                {label}
            </Typography>

            <FormControl variant='outlined' className={classes.textInput} error={error} disabled={disable}>
                <Autocomplete
                    open={open}
                    multiple
                    openOnFocus
                    disabled={disable}
                    value={state}
                    options={allOption}
                    getOptionLabel={({ name }) => name}
                    filterSelectedOptions={true}
                    onChange={(_: SyntheticEvent<Element, Event>, value) => dispatch(state, value)}
                    onOpen={handleOpen}
                    onClose={() => {
                        setOpen(false);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label=''
                            size='small'
                            variant='outlined'
                            placeholder={`Select ${label}`}
                        />
                    )}
                    ChipProps={{
                        sx: {
                            pointerEvents: disable ? 'none' : 'auto',
                        },
                    }}
                    renderOption={(props, option) => (
                        <li {...props} key={option.id}>
                            {option.name}
                        </li>
                    )}
                    renderTags={(selected, getTagProps) =>
                        selected.map((value, index) => (
                            <Chip
                                size='small'
                                label={value.name}
                                {...getTagProps({ index })}
                                key={index}
                                color='primary'
                                disabled={disable}
                                onClick={(e) => {
                                    if (disable) e.stopPropagation();
                                }}
                            />
                        ))
                    }
                    isOptionEqualToValue={(option, value) => option.name === value.name && option.id === value.id}
                />
            </FormControl>
        </Grid>
    );
};
